export const FWN_SCRIPT_URL = process.env.NEXT_PUBLIC_FIREWORK_VERSION_LIVECOMMERCE ?? "";

export const FWN_SCRIPT_SELECTOR = 'script[data-fw="fwn"]' as const;

export const NEWRELIC_HTML5_VIDEO_CONFIG = {
  beacon: "bam.nr-data.net",
  applicationID: "1120493008",
  licenseKey: "NRBR-6016ea1436e9a417fd8",
};
